interface Props {
    warningMessage: string | null;
    warningClose: () => void;
}

export default function InputFormatWarning({ warningMessage, warningClose }: Props) {
    return (
        <div role="alert" className="flex items-start gap-2 border-b border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
            <svg className="mt-0.5 h-4 w-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M12 9v4" />
                <path d="M12 17h.01" />
                <path d="M10.3 3.9 2.5 17.4A2 2 0 0 0 4.2 20h15.6a2 2 0 0 0 1.7-2.6L13.7 3.9a2 2 0 0 0-3.4 0Z" />
            </svg>
            <span className="flex-1">{warningMessage}</span>
            <button type="button" onClick={warningClose} aria-label="Dismiss warning" className="shrink-0 font-semibold text-amber-900 hover:text-amber-950">
                ✕
            </button>
        </div>
    )
}
